export const EventBusName = {
    CUSTOMER_CREATED: 'CUSTOMER_CREATED',
    UNAUTHORIZED_REQUEST: 'UNAUTHORIZED_REQUEST',
    DOMAIN_NOT_SUPPORT: 'DOMAIN_NOT_SUPPORT'
}